import * as schemaUtils from '@flows/configs/shared/schemaUtils'
import type { StepConfigParams } from '@flows/configs/types'
import type { AnyStepConfiguration } from '@flows/core/types/stepTypes'
import { BaseSchema_UnifiedLegalComfort3BasicRolandDe } from '@flows/insurance/schemas'

const legal_partner_name = (params: StepConfigParams) =>
  ({
    schema: schemaUtils.generateZodObjectFromPaths({
      [params.helperFunctions.getParamPath('partner_first_name')]:
        BaseSchema_UnifiedLegalComfort3BasicRolandDe.shape.partner_first_name.unwrap(),
      [params.helperFunctions.getParamPath('partner_last_name')]:
        BaseSchema_UnifiedLegalComfort3BasicRolandDe.shape.partner_last_name.unwrap(),
    }),
    stepContent: [
      {
        type: 'title',
        text: {
          type: 'translatableText',
          translationKey: 'sharedFlows_legal:steps.partner.name.title',
        },
      },
      {
        type: 'input',
        shouldTrackValues: true,
        name: params.helperFunctions.getParamPath('partner_first_name'),
        label: {
          type: 'translatableText',
          translationKey: 'sharedFlows_common:steps.email_and_name.firstName.input.label',
        },
      },
      {
        type: 'input',
        name: params.helperFunctions.getParamPath('partner_last_name'),
        label: {
          type: 'translatableText',
          translationKey: 'sharedFlows_common:steps.email_and_name.lastName.input.label',
        },
      },
    ],
    subFlow: params.subFlow,
    nextStep: 'legal_quote',
  }) as const satisfies AnyStepConfiguration

export default legal_partner_name
